import { defineMessages } from 'react-intl';

export default defineMessages({
    Accounts: {
        id: 'ml.common.component.MLRecurringPaymentComponent.Accounts',
        defaultMessage: 'Accounts'
    },
    Actions: {
        id: 'ml.common.component.MLRecurringPaymentComponent.Actions',
        defaultMessage: 'Actions'
    },
    Edit: {
        id: 'ml.common.component.MLRecurringPaymentComponent.Edit',
        defaultMessage: 'Edit'
    },
    Remove: {
        id: 'ml.common.component.MLRecurringPaymentComponent.Remove',
        defaultMessage: 'Remove'
    },
    InstrumentOptionName: {
        id: 'ml.common.component.MLRecurringPaymentComponent.x - ending in x',
        defaultMessage: '{nickname} - ending in {last4Digits}'
    },
    AddAccount: {
        id: 'ml.common.component.MLRecurringPaymentComponent.ADD ACCOUNT',
        defaultMessage: 'ADD ACCOUNT'
    },
    AlternatePayor: {
        id: 'ml.common.component.MLRecurringPaymentComponent.Alternate Payor',
        defaultMessage: 'Alternate Payor'
    },
    WhatIsThis: {
        id: 'ml.common.component.MLRecurringPaymentComponent.What is this?',
        defaultMessage: 'What is this?'
    },
    FailedToRemoveAccount: {
        id: 'ml.common.component.MLRecurringPaymentComponent.Failed to remove account',
        defaultMessage: 'Failed to remove account'
    },
    FailedToRemoveAccountMessage: {
        id: 'ml.common.component.MLRecurringPaymentComponent.Sorry we are not able to remove this account at this time',
        defaultMessage: 'Sorry we are not able to remove this account at this time'
    },
    AlternatePayorTooltipContent: {
        id: 'ml.common.component.MLRecurringPaymentComponent.Alternate payor tooltip content',
        defaultMessage: 'When a third party will be responsible for paying the policy premium (example – parent paying for child’s policy).  The account name and number entered must be for the third party.   An authorization form will be sent and must be completed by the third party and returned to the company.'
    },
    NoInformation: {
        id: 'ml.common.component.MLRecurringPaymentComponent.No information is available to display',
        defaultMessage: 'No information is available to display'
    },
    CreditCardNotListed: {
        id: 'ml.common.component.MLRecurringPaymentComponent.A credit card is not listed on file.',
        defaultMessage: 'A credit card is not listed on file.  To add, select ADD ACCOUNT.'
    },
    BankAccountNotListed: {
        id: 'ml.common.component.MLRecurringPaymentComponent.A checking or savings account is not listed on file.  To add, select ADD ACCOUNT.',
        defaultMessage: 'A checking or savings account is not listed on file.  To add, select ADD ACCOUNT.'
    },
    preferredPaymentMethodErrorMessage: {
        id:'ml.common.component.MLRecurringPaymentComponent.We are unable to set up the Recurring Payment option',
        defaultMessage: 'We are unable to set up the Recurring Payment option with a credit card since the Preferred Payment Method was selected and this discount is being applied. Please select a different payment method or update the Preferred Payment Method question in the Payment Frequency section.'
    }
});
